import { render, staticRenderFns } from "./record.vue?vue&type=template&id=534a93f3&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.vue?vue&type=style&index=0&id=534a93f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a93f3",
  null
  
)

export default component.exports